import React from "react";
import { Box, Grid } from "@mui/material";
import { Field } from "react-final-form";
import {
    renderInput,
    RenderSelect,
    RenderDatePicker,
} from "../../../Forms/FormFields";
import { RenderAutocompleteMultiple } from "../../../Forms/renderAutocompleteMultiple";
import {
    checkCommaAndBackSlashOnTags,
} from "../../../../lib/validationHelper";
import { createFilterOptions } from "@mui/material/Autocomplete";

const captureDataBoxStyle = {
    minWidth: ["100px"],
    width: "100%",
    overflow: "hidden",
};


const TrayFields = ({ form, trapTypeAutoCompleteOptions, loading, trapSites, trayId, tagsOptions, setHasValidationErrors }) => {
    return (
        <Box
            borderRadius={1}
            style={captureDataBoxStyle}
            sx={{ pt: '10px' }}  >
            <div
                className={"flex flex-1 flex-col"}
                id={"trap-info"} >
                <Grid container spacing={{ md: 3, }} fullWidth rowSpacing={5} >
                    <Grid size={12} >
                        <Grid container spacing={1}>
                            <Grid size={4}>
                                <Field
                                    key="trapType"
                                    label="Collection Method"
                                    name="trapType"
                                    inputProps={{
                                        id: "trap-type-field",
                                        "data-testid": "collection-method",
                                    }}
                                    options={trapTypeAutoCompleteOptions || []}
                                    disabled={loading}
                                    component={RenderSelect}
                                    getOptionLabel={(value) => {
                                        return (
                                            trapTypeAutoCompleteOptions?.find(
                                                (option) => option?.id === value
                                            )?.displayName || ""
                                        );
                                    }}
                                    isOptionEqualToValue={(option, value) => {
                                        return option?.id === value;
                                    }}
                                    filterOptions={createFilterOptions({
                                        matchFrom: "any",
                                        stringify: (option) => option?.displayName,
                                    })}
                                /></Grid>
                            <Grid size={4}>
                                <Field
                                    key="trapSiteId"
                                    data-testid="collection-site"
                                    id="Collection Site"
                                    label="Collection Site"
                                    name="trapSiteId"
                                    autocompleteProps={{
                                        id: "trap-site-field",
                                        // style: { width: "100%" },
                                    }}
                                    disabled={loading}
                                    options={trapSites || []}
                                    getOptionLabel={(value) => {
                                        return (
                                            trapSites?.find(
                                                (option) => option?.id === value
                                            )?.displayName || ""
                                        );
                                    }}
                                    isOptionEqualToValue={(option, value) => {
                                        return option?.id === value;
                                    }}
                                    getOptionKey={(option) => {
                                        return option?.id || "";
                                    }}
                                    filterOptions={createFilterOptions({
                                        matchFrom: "any",
                                        stringify: (option) => option.displayName,
                                    })}
                                    component={RenderSelect}
                                />
                            </Grid>
                            <Grid size={4}>
                                <Field
                                    key="captureDate"
                                    label="Specimen Collection Date"
                                    name="captureDate"
                                    disabled={loading}
                                    component={RenderDatePicker}
                                    inputProps={{
                                        "data-testid": "capture-date",
                                    }}
                                    setHasErrorsFlag={setHasValidationErrors}
                                    cusMinDate="1900-01-01"
                                    trayId={trayId}
                                    handleChange={() => { }}

                                />
                            </Grid>
                        </Grid>

                    </Grid>

                    <Grid size={6}>
                        <Box
                            className={"flex flex-1 flex-col"}
                            sx={{
                                mt: "-1.5rem"
                            }}
                        >
                            <Field
                                key="notes"
                                data-testid="notes"
                                label="Notes"
                                name="notes"
                                inputProps={{
                                    id: "tray-notes",
                                    multiline: true,
                                    maxRows: 5,
                                    fullWidth: true,
                                }}
                                testId="notes"
                                disabled={loading}
                                handleChange={() => { }}
                                component={renderInput}
                            />
                        </Box>
                    </Grid>

                    <Grid size={6} sx={{ marginTop: "-1.5rem" }}>
                        <Field
                            label="Tray Tags"
                            name={`tags`}
                            inputProps={{ id: `tags` }}
                            component={RenderAutocompleteMultiple}
                            fieldValue={form?.values?.tags}
                            // onChange={(event, value) => {
                            //     form.form.mutators.setValue("tags", [
                            //         ...value,
                            //     ]);
                            // }}
                            options={tagsOptions || []}
                            onBlur={(e) => e.preventDefault()}
                            multiple={true}
                            validate={checkCommaAndBackSlashOnTags}
                        />
                    </Grid>
                </Grid>
            </div>
        </Box>
    )
}

export default TrayFields;